import { TRIGGER_TYPE, trigger_types_names } from '@voladeum/client';
import { Trigger } from 'client/voladeum/triggers/types';

export const trigger_default: Trigger = {
  trigger_id: 0,
  trigger_name: '',
  strategy_id: 0,
  trigger_type_id: TRIGGER_TYPE.BUY,
  trigger_type_name: trigger_types_names[TRIGGER_TYPE.BUY],
  option_type_id: null,
  option_type_name: null,
  position_pct: 0.1,
  position_pct_formatted: '10%',
  weight: 1,
  weight_formatted: '1',
  conditions: [],
  created_date: new Date(),
  update_date: new Date(),
  uuid: '',
};
